(function () {
  async function syncImpactHeaderCartCount() {
    try {
      const cart = await fetch('/cart.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then((response) => response.json());

      document
        .querySelectorAll('.header__cart-count cart-count, cart-count')
        .forEach((countElement) => {
          countElement.textContent = cart.item_count;

          if (cart.item_count > 0) {
            countElement.classList.remove('opacity-0');
            countElement.style.opacity = '1';
          } else {
            countElement.classList.add('opacity-0');
            countElement.style.opacity = '';
          }
        });
    } catch (error) {
      console.error('[Instant cart] Failed to sync Impact header cart count:', error);
    }
  }

  document.addEventListener('instant:cart-updated', syncImpactHeaderCartCount);
  document.addEventListener('instant:add-to-cart', syncImpactHeaderCartCount);
})();